module.exports = __webpack_public_path__ + "img/P9.ec1c07cc.png";